// ─────────────────────────────────────────────────────────────────────────
// facilityPhotos.js
//
// The photos in /public/pic were taken at Dekyi. They show on the login
// carousel and the public website only for a facility that should use them;
// every other facility gets the neutral images in /public/login-defaults.
//
//   • A build pointed at Dekyi's server uses the original photos by default.
//   • The facility setting `login_use_original_photos` ('true' / 'false')
//     overrides that either way (Admin → Hospital Admin Settings → Module
//     Toggles).
// ─────────────────────────────────────────────────────────────────────────

import { URL as BASE_URL } from '../Components/BaseURL';

export const ORIGINAL_PHOTOS_KEY = 'login_use_original_photos';

export const IS_ORIGINAL_PHOTO_SITE = /dekyidiagnostics/i.test(BASE_URL);

export function shouldUseOriginalPhotos(flag) {
  const s = String(flag ?? '').trim().toLowerCase();
  if (s === 'true')  return true;
  if (s === 'false') return false;
  return IS_ORIGINAL_PHOTO_SITE;
}

// Reads the setting out of a /facilitySettings response body.
export function originalPhotosFromSettings(data) {
  const flag = data?.success && Array.isArray(data.results)
    ? data.results.find((r) => r.key === ORIGINAL_PHOTOS_KEY)?.value
    : null;
  return shouldUseOriginalPhotos(flag);
}
